import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { SanitizeHtmlPipe } from '@shared/pipes/sanitize-html.pipe';

@Component({
  selector: 'app-success-message',
  standalone: true,
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss'],
  imports: [CommonModule, TranslateModule, FlexLayoutModule, MatButtonModule, SanitizeHtmlPipe]
})
export class SuccesMessageComponent implements OnInit {
  private activatedRoute: ActivatedRoute = inject(ActivatedRoute);

  title = '';
  description = '';
  yourID = '';
  isClaim = false;
  isOtherPurpose = false;

  ngOnInit(): void {
    const { id, type } = this.activatedRoute.snapshot.params;
    switch (type) {
      case 'homeQuote':
        this.title = 'keywords.quotes_module.home_quote_has_been_received';
        this.yourID = id;
        this.isClaim = false;
        break;

      case 'homeClaim':
        this.title = 'keywords.claims_module.success_home_policy_title';
        this.description = 'keywords.claims_module.success_home_policy_description';
        this.yourID = id;
        this.isClaim = true;
        break;

      case 'motorClaim':
        this.title = 'keywords.claims_module.success_motor_policy_title';
        this.description = 'keywords.claims_module.success_motor_policy_description';
        this.yourID = id;
        this.isClaim = true;
        break;

      case 'healthClaim':
        this.title = 'keywords.claims_module.success_health_policy_title';
        this.description = 'keywords.claims_module.success_health_policy_description';
        this.yourID = id;
        this.isClaim = true;
        break;

      case 'policyCreated':
        this.title = 'keywords.quotes_module.policyCreatedTitle';
        //this.description = 'keywords.quotes_module.policyCreatedDesc';
        this.yourID = id;
        this.isClaim = false;
        break;

      case 'payments':
        this.title = 'keywords.policyModul.yourPolicyHasPaid';
        this.description = 'keywords.paymentModul.successPaymentDescription';
        this.yourID = id;
        this.isClaim = false;
        break;

      case 'otherPurpose':
        this.title = 'keywords.quotes_module.other_purpose';
        this.yourID = '';
        this.isClaim = false;
        this.isOtherPurpose = true;
        break;
    }
  }

  goToDashboard() {
    window.location.href = '/dashboard';
  }
}
